import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { IDisabled } from '../../interfaces/IHasChanges';

@Component({
  selector: 'app-button[iconName]',
  templateUrl: 'button.component.html',
  styleUrls: ['button.component.scss'],
  imports: [MatTooltip, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class ButtonComponent<T extends IDisabled> {
  @Input() iconName: string;
  @Input() row: T;
  @Input() disabled: boolean;
  @Input() tooltip = '';
  @Output() buttonClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  public get isDisabled(): boolean {
    return this.iconName === 'delete' ? this.disabled : this.row.disabled;
  }
}
